//note make ..env file and create VUE_APP_API_URL
export const API_URL = process.env.VUE_APP_API_URL;
export const BASE_URL = process.env.VUE_APP_BASE_URL;
export const REMOTE_URL = process.env.VUE_APP_REMOTE_URL;
export const ENV_STATUS = process.env.ENV_STATUS;

export const TOKEN = "FUJI_ACCTG_TOKEN";

export const ERROR_FIELD = 2;
export const INITIAL_FIELD = 0;
export const SUCCESS_FIELD = 1;
export const ENTITIES = ['agent', 'supplier', 'customer', 'employee', 'purchaser', 'subcontractor']
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
export const YEARS = ['2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030']

export const QUARTERS = [''];
export const FIELD_STATUS_COLORS = {
    0: "",
    1: "isValidStyle",
    2: "isInvalidStyle"
}

export const FIELD_STATUS_BOOTSTRAP_BASE = {
    0: "",
    1: "is-valid",
    2: "is-invalid"
}

export const VENDOR_CUSTOMER_FILE_TYPES = ["application/pdf"]

export const INPUT_TYPES = [
    'text',
    'number',
    'checkbox',
    'multiselect',
    'dropdown',
    'email',
    'radio',
    'file',
    'date',
    'datetime-local',
    // 'image',
    'month',
    'year',
    'color',
    'password',
    // 'range',
    // 'reset',
    // 'search',
    'tel',
    // 'time',
    'url',
    'week',
]

export const RFP_TRANSACTION_STATUSES = {
    "draft": "Draft",
    "approved": "Approved",
    "received": "Received",
    "returned": "Returned",
    "cancelled": "Cancelled",
    "sent": "Sent",
}

export const DATA_TYPES = [
    'string', 'integer', 'decimal', 'currency', 'Date', 'File', 'boolean'
]

export const CODE_TYPES = [
    { code: 'code', name: 'Code' },
    { code: 'voucher_code', name: 'Voucher No.' }
]

export const FILE_EXTENSIONS = {
    image : ['apng', 'png', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'],
    video : ['mkv', 'flv', 'vob', 'ogg', 'drc', 'avi', 'wmv', 'avchd', 'flv', 'mp4'],
    excel : ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xml', 'xlam', 'xla', 'xlw', 'xlr'],
    word : ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx']
}
export const ERROR_MESSAGES = { required_fields: 'Please fill in required fields or check field format!' }
export const MODULES= {
    "billing": {module: 'billing', text: 'Billing'},
    "journal": {module: 'journal', text: 'Journal Voucher'},
    "disbursement": {module: 'disbursement', text: 'Disbursement Voucher'},
    "receipt": {module: 'receipt', text: 'Receipt Voucher'},
    "receivable": {module: 'receivable', text: 'Accounts Receivable'},
    "payable": {module: 'payable', text: 'Accounts Payable'},
    "prepaid": {module: 'prepaid', text: 'Prepaid Expenses'},
    "advances": {module: 'advances', text: 'Cash Advance'},
    "liquidation": {module: 'liquidation', text: 'Liquidation'},
}

export const MOTHER_MODULES = {
    "dashboard": {code: "dashboard", name: "Dashboard"},
    "transactions": {code: "transactions", name: "Transactions"},
    "reports": {code: "reports", name: "Reports"},
    'management': {code: "management", name: "Management"},
    'monitoring': {code: "monitoring", name: "Monitoring"},
    "entities": {code: "entities", name: "Entities"},
    "setup": {code: "setup", name: "Setup"},
    'branch_liquidation': {code: "branch_liquidation", name: "Branch Liquidation"},
}

export const FILE_ICON_CONFIG = {
    image: {
        icon: ['fas', 'image'],
        color: '#eb8034'
    },
    video: {
        icon: ['fas', 'film'],
        color: '#3fb1d4'
    },
    word: {
        icon: ['fas', 'file-word'],
        color: 'blue'
    },
    excel: {
        icon: ['fas', 'file-excel'],
        color: 'green'
    },
    pdf: {
        icon: ['fas', 'file-pdf'],
        color: 'red'
    },
}

export const FILE_ICON_DISPLAY = {
    image: ['apng', 'png', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'],
    video: ['mkv', 'flv', 'vob', 'ogg', 'drc', 'avi', 'wmv', 'avchd', 'flv', 'mp4'],
    word: ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx'],
    excel: ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xml', 'xlam', 'xla', 'xlw', 'xlr'],
    pdf: ['pdf']
}

export const COLOR_PALETTE = ['(232, 228, 16', '(221, 102, 17', '(63, 187, 178', '(68, 204, 255',
    '(42, 82, 190', '(29, 77, 160', '(255, 111, 252', '(97, 102, 105', '(238, 221, 130', '(215, 211, 166',
    '(173, 198, 211', '(237, 184, 199', '(192, 216, 235', '(221, 218, 206', '(244, 235, 188', '(244, 216, 198',
    '(232, 228, 16', '(221, 102, 17', '(63, 187, 178', '(68, 204, 255', '(42, 82, 190', '(29, 77, 160',
    '(255, 111, 252', '(97, 102, 105', '(238, 221, 130', '(215, 211, 166', '(173, 198, 211', '(237, 184, 199',
    '(192, 216, 235', '(221, 218, 206', '(244, 235, 188', '(244, 216, 198']

export const REPORT_FILTERS = {
    'as_of': 'As of',
    'range': 'Range',
    'quarter': 'Quarter',
    'month': 'Month'
}

export const COMPARATIVE_TYPES = {
    'none' : 'None',
    'year': 'Year',
    'month': 'Month',
    'quarter': 'Quarter'
}
